type FulfilmentTarget =
  'shops' | 'shopGroups' | 'shopOwners' | 'dateRange' | null;

interface ApiResponse {
  status: number;
  data: unknown;
}

interface FulfilmentEntity {
  name?: string;
  third_party_id?: string;
  [key: string]: unknown;
}

export const fetchDefaultFulfilmentData = async (
  clientId: string,
  target: FulfilmentTarget = null
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { $clientAccount } = useNuxtApp() as any;
  const insightsStore = useInsightsStore();
  const selectedClientId = clientId;

  const extractData = (response: ApiResponse) => {
    if (response?.status === 200 && response.data)
      return response.data as FulfilmentEntity[];
    throw new Error('Invalid or empty response data');
  };

  const simplifyFulfilmentArray = (entities: FulfilmentEntity[]) => {
    if (!Array.isArray(entities)) return [];
    return entities
      .filter(entity => entity && typeof entity === 'object')
      .map(entity => ({
        name: entity.name || '',
        third_party_id: entity.third_party_id || '',
      }));
  };
  // Prepare promises
  const shopsPromise =
    !target || target === 'shops'
      ? $clientAccount.shopctrlConfig.shops
          .list(selectedClientId, {
            client_id: selectedClientId,
            third_party: 'shopctrl_oms',
          })
          .then(extractData)
      : Promise.resolve([]);
  const shopGroupsPromise =
    !target || target === 'shopGroups'
      ? $clientAccount.shopctrlConfig.groups
          .list(selectedClientId, {
            client_id: selectedClientId,
            third_party: 'shopctrl_oms',
          })
          .then(extractData)
      : Promise.resolve([]);
  const shopOwnersPromise =
    !target || target === 'shopOwners'
      ? $clientAccount.shopctrlConfig.owners
          .list(selectedClientId, {
            client_id: selectedClientId,
            third_party: 'shopctrl_oms',
          })
          .then(extractData)
      : Promise.resolve([]);

  // Fetch data directly instead of using useAsyncData
  try {
    const [shops, shopGroups, shopOwners] = await Promise.all([
      shopsPromise,
      shopGroupsPromise,
      shopOwnersPromise,
    ]);

    if (shops.length > 0)
      insightsStore.updateSelectedOMSShop(simplifyFulfilmentArray(shops));
    if (shopGroups.length > 0)
      insightsStore.updateSelectedShopGroup(
        simplifyFulfilmentArray(shopGroups)
      );
    if (shopOwners.length > 0)
      insightsStore.updateSelectedShopOwner(
        simplifyFulfilmentArray(shopOwners)
      );

    if (!target || target === 'dateRange') {
      insightsStore.updateSelectedDateRange(getDefaultDateRange());
    }
  } catch {
    // Error handling would go here if needed
  }
};
